<div id="about-application" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title">{{'About' | translate}} {{appName}}</h5>
      </div>
      <div class="modal-body">
        <p><strong translate>Copyright © Ilerian Software Technologies Ltd.</strong></p>
        <p><strong translate>Web Application Release:</strong>&nbsp;<span id="version"></span></p>
        <label><strong translate>Licenses</strong></label>
        <div id="licenses"></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" data-dismiss="modal" translate>Done</button>
      </div>
    </div>
  </div>
</div>
